export default __webpack_public_path__ + "assets/images/b6b3535bceaa91d436e74d6a966f8d88.png";